import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { BUSINESS, NAV, PARTNER_LINKS, COUNTIES } from "../data/site";
import { IMAGES } from "../mock/mock";

const Footer = () => (
  <footer className="bg-[#0b0b0b] border-t border-[#c9a24b]/20 pt-16 pb-8">
    <div className="max-w-7xl mx-auto px-5 md:px-8">
      <div className="grid md:grid-cols-4 gap-10 mb-12">
        <div className="md:col-span-1">
          <div className="flex items-center gap-3 mb-4">
            <img src={IMAGES.logo} alt="Build Highland Homes logo" className="h-12 w-12 object-cover rounded-sm ring-1 ring-[#c9a24b]/40" />
            <div>
              <p className="font-serif-display text-lg gold-gradient-text font-semibold leading-none">Build Highland Homes</p>
              <p className="text-[9px] tracking-[0.2em] uppercase text-[#a39d90] mt-1">Custom Home Builder</p>
            </div>
          </div>
          <p className="text-[#a39d90] leading-relaxed text-sm">Designing and building custom homes on your lot across Central Florida — with craftsmanship that stands the test of time.</p>
        </div>

        <div>
          <h4 className="font-serif-display text-lg text-[#e3c77a] mb-4">Explore</h4>
          <ul className="space-y-2.5">
            {NAV.map((n) => (
              <li key={n.to}><Link to={n.to} className="text-[#a39d90] hover:text-[#e3c77a] transition-colors text-sm">{n.label}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-serif-display text-lg text-[#e3c77a] mb-4">Service Areas</h4>
          <ul className="space-y-2.5">
            {COUNTIES.map((c) => (
              <li key={c.slug}><Link to={`/locations/${c.slug}`} className="text-[#a39d90] hover:text-[#e3c77a] transition-colors text-sm">{c.name}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-serif-display text-lg text-[#e3c77a] mb-4">Contact</h4>
          <a href={`mailto:${BUSINESS.email}`} className="flex items-center gap-2 text-[#a39d90] hover:text-[#e3c77a] transition-colors text-sm mb-3 break-all"><Mail size={16} /> {BUSINESS.email}</a>
          {BUSINESS.phones.map((p) => (
            <a key={p} href={`tel:${p.replace(/[^0-9]/g, "")}`} className="flex items-center gap-2 text-[#a39d90] hover:text-[#e3c77a] transition-colors text-sm mb-2"><Phone size={16} /> {p}</a>
          ))}
          <p className="flex items-center gap-2 text-[#a39d90] text-sm mt-2"><MapPin size={16} /> {BUSINESS.areaServedText}</p>
          <div className="mt-5 flex flex-col gap-2">
            <span className="text-[10px] uppercase tracking-widest text-[#7a766c]">Our Partners</span>
            {PARTNER_LINKS.map((p) => (
              <a key={p.href} href={p.href} target="_blank" rel="noopener noreferrer" className="text-[#a39d90] hover:text-[#e3c77a] transition-colors text-sm">{p.label}</a>
            ))}
          </div>
        </div>
      </div>

      <div className="gold-divider w-full mb-6" />
      <div className="flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-[#7a766c]">
        <p>© {new Date().getFullYear()} Build Highland Homes. All rights reserved.</p>
        <p>Custom Home Builder · Serving Central Florida</p>
      </div>
    </div>
  </footer>
);

export default Footer;
